import { gql } from 'graphql-tag'

export const getNavigation = gql`
  query GetNavigation($site: [String]) {
    globalSets(site: $site) {
      ... on navigationLayout_GlobalSet {
        id
        navigationPages {
          id
          title
          slug
          ... on vinoPage_Entry {
            key
          }
          ... on birraPage_Entry {
            key
          }
          ... on agricolturaPage_Entry {
            key
          }

          ... on nutraceuticaPage_Entry {
            key
          }
          ... on panificatiPage_Entry {
            key
          }
        }
      }
      ... on navigationHighlight_GlobalSet {
        id
        highlightTitle
        highlightUrl
        highlightImage {
          id
          title
        }
        portrait: highlightImage
          @transform(format: "webp", width: 300, height: 300) {
          id
          url
          width
          srcset(sizes: ["750w", "1000w"])
          height
          title
        }
      }
    }
    categories(site: $site) {
      ... on categoriaProdottoVino_Category {
        id
        slug
        title
        key
        algoliaKey
      }
    }
    comeFarePerEntries(site: $site) {
      ... on comeFarePer_Entry {
        id
        title
        slug
      }
    }
  }
`
